import React from 'react';
import { IAuditoriaTributo, TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  cards: IAuditoriaTributo[];
  onSelecionarTributo: (tributo: TributoAuditoria) => void;
}


const getCompensacaoSaldo = (card: IAuditoriaTributo) =>
  card.compensacaoSaldo ?? card.confrontoRealizadoNoFechamento ?? 0;

const getPotencialCompensacao = (card: IAuditoriaTributo) =>
  card.potencialCompensacaoNaoAproveitado ?? card.dinheiroDeixouDeCompensar ?? 0;

const AuditoriaTabelaTributos: React.FC<Props> = ({ cards, onSelecionarTributo }) => {
  if (!cards || cards.length === 0) {
    return (
      <div className='auditoria-card'>
        <h3>Resumo por Tributo</h3>
        <div className='text-muted mt-4'>Nenhum resultado encontrado para os filtros selecionados.</div>
      </div>
    );
  }

  return (
    <div className='auditoria-card'>
      <h3>Resumo por Tributo</h3>
      <p className='text-muted'>Clique em um tributo para ver a análise detalhada por período.</p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Tributo</th>
              <th className='text-end'>Faturamento do Período</th>
              <th className='text-end'>Provisão / Tributo a Recolher</th>
              <th className='text-end'>Compensação do Saldo</th>
              <th className='text-end'>Saldo a Recolher</th>
              <th className='text-end'>Valor Pago</th>
              <th className='text-end'>Saldo Compensação Não Utilizado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            {cards.map((card) => (
              <tr
                key={card.tributo}
                className='auditoria-row-tributo'
                onClick={() => onSelecionarTributo(card.tributo)}
              >
                <td className='auditoria-col-tributo'>
                  <div className='d-flex align-items-center gap-2'>
                    <strong>Auditoria do {card.tributo}</strong>
                    <span className={`auditoria-status status-${card.status}`} title={card.mensagemDirecionamento}>
                      {card.status}
                    </span>
                  </div>
                  <div className='auditoria-legislacao-inline'>
                    <div>Contábil: {card.legislacaoContabil}</div>
                    <div>Fiscal: {card.legislacaoFiscal}</div>
                  </div>
                </td>
                <td className='text-end'>{formatCurrency(card.faturamentoFiscal)}</td>
                <td className='text-end'>{formatCurrency(card.saldoProvisaoRealPassivo)}</td>
                <td className='text-end'>{formatCurrency(getCompensacaoSaldo(card))}</td>
                <td className='text-end'>
                  {(card.valorResidualAberto ?? 0) > 0 ? (
                    <div className='d-flex align-items-center justify-content-end gap-1'>
                      <span className='auditoria-residual-erro'>{formatCurrency(card.valorResidualAberto)}</span>
                      <span className='auditoria-status status-ERRO' style={{ fontSize: 10, padding: '2px 7px' }}>ERRO</span>
                    </div>
                  ) : (
                    <span className='text-muted'>—</span>
                  )}
                </td>
                <td className='text-end'>{formatCurrency(card.valorPagoTotal)}</td>
                <td className='text-end'>{formatCurrency(getPotencialCompensacao(card))}</td>
                <td className='text-center'>
                  <span className='auditoria-contador auditoria-contador-erro'>{card.totalErros}</span>
                </td>
                <td className='text-center'>
                  <span className='auditoria-contador auditoria-contador-aviso'>{card.totalAvisos}</span>
                </td>
                <td className='text-center'>
                  <span className='auditoria-contador auditoria-contador-alerta'>{card.totalAlertas}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaTabelaTributos;
